import React, { useCallback, useContext, useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles/selection-group-item.module.css';
import { Radio } from '../radio';
import { SelectionGroupContextData, SelectionGroupContextDispatcher } from './selection-group-context';
import { Checkbox } from '../checkbox';
import { Icon } from '../icon';
export const SelectionGroupItem = ({
  className = '',
  children,
  value,
  name,
  iconLeft,
  iconRight,
  iconOnly,
  ...props
}) => {
  const {
    onChangeSelection,
    active
  } = useContext(SelectionGroupContextDispatcher);
  const {
    variant = 'accent',
    size = 'm',
    extraCheck,
    rounded
  } = useContext(SelectionGroupContextData);
  const isActive = useMemo(() => {
    if (Array.isArray(active) && active.includes(value)) {
      return true;
    }
    return (typeof active === 'number' || typeof active === 'string') && active.toString() === value;
  }, [active, value]);
  const noHover = useMemo(() => !Array.isArray(active) && isActive, [active, isActive]);
  const selectionGroupItemRootClass = useMemo(() => clsx(styles.selectionGroupItem, styles[variant], styles[size], {
    [styles.splitted]: extraCheck,
    [styles.noHover]: noHover,
    [styles.rounded]: rounded,
    [styles.square]: iconOnly
  }, className), [variant, size, extraCheck, noHover, rounded, iconOnly, className]);
  const onChangeActiveHandler = useCallback(event => onChangeSelection(event, value), [onChangeSelection, value]);
  const iconSize = size ? iconSizesByButtonSize[size] : 0;
  return /*#__PURE__*/React.createElement("button", {
    className: selectionGroupItemRootClass,
    onClick: onChangeActiveHandler,
    name: name,
    type: "button",
    "aria-pressed": isActive,
    "data-testid": "selection-group-item",
    ...props
  }, extraCheck && (/*#__PURE__*/React.createElement("span", {
    className: styles.extraCheck
  }, extraCheck.type === 'radio' && (/*#__PURE__*/React.createElement(Radio, {
    className: styles.extraCheckItem,
    checked: isActive,
    value: value,
    name: name,
    radioSize: extraCheck.size,
    tabIndex: -1
  })), extraCheck.type === 'checkbox' && (/*#__PURE__*/React.createElement(Checkbox, {
    className: styles.extraCheckItem,
    checked: isActive,
    size: extraCheck.size,
    tabIndex: -1,
    withExtraClickZone: true
  })))), /*#__PURE__*/React.createElement("span", {
    className: styles.contentWrap
  }, iconLeft && (/*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    className: styles.iconLeft
  }, iconLeft)), iconOnly ? /*#__PURE__*/React.createElement(Icon, {
    size: iconSize
  }, children) : children, iconRight && (/*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    className: styles.iconRight
  }, iconRight))));
};
const iconSizesByButtonSize = {
  s: 20,
  m: 20,
  l: 24
};